/* eslint-disable */
import { produce } from "immer";
import {
  GET_DOCUMENT_FETCH_START,
  GET_DOCUMENT_FETCH_SUCCESS,
  GET_DOCUMENT_FETCH_FAILURE,
  RESET_GET_DOCUMENT_DATA,
  DOCUMENT_READ_STATUS_POST_FETCH_START,
  DOCUMENT_READ_STATUS_POST_FETCH_SUCCESS,
  DOCUMENT_READ_STATUS_POST_FETCH_FAILURE,
  RESET_GET_DOCUMENT_ERROR,
} from "../actions/types";

const documentReducer = (
  state = {
    // for single doc data
    getDocumentFetching: false,
    getDocumentData: {},
    getDocumentError: null,

    // for update doc read status
    isReadDocumentFetching: false,
    isReadDocumentData: undefined,
    isReadDocumentError: null,
  },
  action,
) => {
  switch (action.type) {
    // for single doc data
    case GET_DOCUMENT_FETCH_START:
      return produce(state, (draft) => {
        draft.getDocumentFetching = true;
      });
    case GET_DOCUMENT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.getDocumentFetching = true;
        draft.getDocumentData = action.data;
        draft.getDocumentFetching = false;
      });
    case GET_DOCUMENT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.getDocumentFetching = false;
        draft.getDocumentError = action.error;
      });
    // For resetting doc data
    case RESET_GET_DOCUMENT_DATA:
      return produce(state, (draft) => {
        draft.getDocumentFetching = false;
        draft.getDocumentData = {};
      });
    // For resetting doc error
    case RESET_GET_DOCUMENT_ERROR:
      return produce(state, (draft) => {
        draft.getDocumentFetching = false;
        draft.getDocumentError = null;
      });
    // For adding doc data read status
    case DOCUMENT_READ_STATUS_POST_FETCH_START:
      return produce(state, (draft) => {
        draft.isReadDocumentFetching = true;
      });
    case DOCUMENT_READ_STATUS_POST_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.isReadDocumentFetching = false;
        draft.isReadDocumentData = action.data;
      });
    case DOCUMENT_READ_STATUS_POST_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.isReadDocumentFetching = false;
        draft.isReadDocumentData = action.error;
      });
    default:
      return state;
  }
};

export default documentReducer;
